import CertificateElement from "./certificateElement";
import CertificateElementHandler from "~/services/certificateElementHandler";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";
import CertificateElementable from "../certificateElementable";
import {certificateElementType} from "~/enums/certificateElementType";
import {CertificateSize} from "../enums/certificateSize";
import {CertificateOrientation} from "../enums/certificateOrientation";
import Certificate from "./certificate";
import Vue from "vue";
import store from "~/state/store";
import {ObjectHelper} from "~/helpers/objectHelper";
import {Hash} from "~/interfaces/hashInterfaces";
import CertificateFoundationLayer from "./certificateFoundationLayer";
export default class AdaptiveLayoutSection extends CertificateElementable(CertificateElement){
  $element: JQuery
  label_title: string;
  page_size: CertificateSize;
  page_orientation: CertificateOrientation;
  isExpanded: boolean = true
  type = certificateElementType.AdaptiveLayoutSection
  page_margin_top: number;
  page_margin_bottom: number;
  page_margin_left: number;
  page_margin_right: number;
  shell_page_margin_top: number= 10;
  shell_page_margin_bottom: number= 10;
  shell_page_margin_left: number= 10;
  shell_page_margin_right: number= 10;
  include_page_numbers: boolean = false;
  page_number_location: string = 'top_right';
  page_number_format_formula: string = null;
  _editing_shell_page_margin_top: boolean= false;
  _editing_shell_page_margin_bottom: boolean= false;
  _editing_shell_page_margin_left: boolean= false;
  _editing_shell_page_margin_right: boolean= false;
  certificate_foundation_layers: Hash<CertificateFoundationLayer> = {};

  static repo: IRepo<AdaptiveLayoutSection> = new Repo<AdaptiveLayoutSection>('adaptiveLayoutSections', AdaptiveLayoutSection);
  _certificateElementHandler = new CertificateElementHandler(this, CertificateElement, 'certificate_elements');

  constructor() {
    super();
    this.defineProperty('include_page_numbers', false);
    this.defineProperty('page_number_location', 'top_right');
    this.defineProperty('page_number_format_formula', null);
  }

  get foundationLayers() {
    return ObjectHelper.toArray(this.certificate_foundation_layers);
  }

  get foundationLayerShell() {
    return store.state.certificateStore.foundationLayerShell;
  }

  get foundationLayerElements(): CertificateElement[] {
    return store.state.certificateStore.foundationLayerElements;
  }

  get shellLayerElements() {
    return store.state.certificateStore.shellLayerElements;
  }

  get section(){
    return this
  }

  get placeHolderText(): string{
    return `Section ${this.sort_order + 1}`
  }

  get rootName(): string {
    return 'adaptive_layout_sections';
  }


  get leftBoundX(){
    return this.page_margin_left
  }

  get totalHorizontalMargin() {
    return this.page_margin_left + this.page_margin_right
  }

  get displayName() : string{
    return this.label_title
  }

  //This is really just generation dimensions
  get dimensions() : {height: number, width: number}{
    let width = 0, height = 0;
    const basePixels = [Certificate.letterPixelDimensions.long, Certificate.letterPixelDimensions.short];
    this.page_orientation === CertificateOrientation.Landscape ? [width, height] = basePixels : [height, width] = basePixels;
    return { width, height };
  }
  scrollToElement(){
    Certificate.$builderCanvasContainer.animate({
      //the -130 makes it so the header of the section is fully in the field of view
      scrollTop: this.$element?.offset()?.top + this.$element?.offsetParent()?.scrollTop() - 130
    }, 1000);
  }


  //********************** Moveable concerns ***********************************
  get isLast(): boolean {
    return this.sort_order >= this.certificate.adaptiveLayoutSectionsArray.length - 1
  }

  get isFirst(): boolean {
    return this.sort_order <= 0;
  }

  clearRepeatableInputs() {
    //  Overwritten where needed
  }

  moveUp(): void {
    if (!this.isFirst) {
      this.sort_order--;
      this.certificate.adaptiveLayoutSectionHandler.updateElementPositions(this.parent, this, this.sort_order);

      Vue.nextTick(()=>{
        this.select()
      })
    }
  }

  moveDown(): void {
    if (!this.isLast) {
      this.sort_order++;
      this.certificate.adaptiveLayoutSectionHandler.updateElementPositions(this.parent, this, this.sort_order);
      Vue.nextTick(()=>{
        this.select()
      })
    }
  }

}
